import React, { useState, useEffect } from 'react';
import styles from '../styles/Home.module.css';

function GetSelectedBatchName() {
  var BatchName
  BatchName = document.getElementById('SelectedBatch').innerHTML
  if ( BatchName === '' )
  {
    BatchName = "Default"
  }
  //else {
    //console.log("FALSE")
    //console.log("JASON>> " + BatchName)}
  return BatchName
}

const Home = ({ study, setStudy, username, batchname }) => {

const [studies, setStudies] = useState({})

const [alldata, setAlldata] = useState({
  res: [
    {
      batchName: '',
      workerID: '',
      startDate: '',
      endDate: '',
      sessionName: '',
      data: '' 
    }
  ]
});


const [alldataAllBatch, setAlldataAllBatch] = useState({
  res: [
    {
      batchName: '',
      workerID: '',
      startDate: '',
      endDate: '',
      sessionName: '',
      data: '' 
    }
  ]
});


const [completed, setCompleted] = useState({
    res:[
      {
        wID: '',
        srID: '',
        crID: '',
        cID: '',
        Name: '',
        Link: ''
      }
    ]
  })


  useEffect(() => {
    //fetch(`/get_studies/${username}`)
    fetch(`/get_studies`)
      .then((response) => response.json())
      .then((data) => {
        setStudies(data);
      });
  }, [username]);



useEffect(() => {
    // Get a list of completed tasks
    fetch( `/get_all_data_from_batch/${GetSelectedBatchName()}`)
    .then((response) => response.json())
        .then((data) => {
          console.log(data)
          var res = data.map((e) => { 
/*            console.log(e.rawData)
            if ( Object.keys(e.rawData).length > 0 ) 
            {
              var elm = Object.keys(e.rawData).map((f) => {
                console.log(f)
             })
          }*/
          if ( e.rawData==null ) {e.rawData = '' }
            return {
              batchName: e.title,
              workerID: e.worker_id,
              sessionResultsID: e.id,
              startDate: e.startDate,
              endDate: e.endDate,
              sessionName: e.BatteryName,
              phase: e.Phase,
              test: e.TestShortName,
              session: e.SessionNumber,
              data: e.rawData,
              FirstName: e.FirstName
            }
          })
          setAlldata({res}) 
        }
    )
  },[] )

const MakeData =((input) => {
  //console.log(input.res)
  console.log("MAKE DATA")
  console.log(input)
  const Nrows = input.res.length
  //console.log(Nrows)

  // Make a list for the different sessions that have corresponding rows.
  var AllSessionResults = []

  // Make the data header row
  // every row will start with the same few entries
  var HeaderRow = []
  HeaderRow.push('site')
  HeaderRow.push('workerID')
  HeaderRow.push('startDate')
  HeaderRow.push('endDate')
  HeaderRow.push('First Name')
  HeaderRow.push('sessionName')
  HeaderRow.push('Phase')
  HeaderRow.push('Test #')
  HeaderRow.push('Session #')
  
  var Str = ''
  // cycle through the data to create the header row labels.
  for ( var i = 0; i < Nrows; i++ )
  {
   //console.log(input.res[i])
    let currentDataKeys = Object.keys(input.res[i].data)
    // Put the header columns in order based on the name values
    // This requires that the names are made in a way that they can be sorted.
    // The intake form uses the format:
    // dem: unique tag to designate the questionnaire 
    // 01: numbers to designate the part o fthe questionnaire. The intake form has 5 parts
    // 01: numbers to designate the question within the section.
    // p1: if there are subparts for a question use p1, p2, p3. These are typicaly for visibleIf conditions.
    // Example: dem0204p2 would be the second part of question 4 in section 2 of the demographic questionnaire. 
    // This would be the part that is only shown if the participant answers a certain way to question 4.
    currentDataKeys = currentDataKeys.sort()
    let NDataKeys = currentDataKeys.length
    for ( var j = 0; j < NDataKeys; j++ )
    {
      if ( ! HeaderRow.includes(currentDataKeys[j]) )
      { HeaderRow.push(currentDataKeys[j])}
    }
        // What is the session for this data?
    let currentSessionResult = input.res[i].sessionResultsID
    // is this session result id in the list already?
    if ( AllSessionResults.indexOf(currentSessionResult) == -1 )
    { AllSessionResults.push(currentSessionResult) } 
  }
  //console.log("What is the list of all sessions")
  //console.log(AllSessionResults)
  let Ncols = HeaderRow.length
  
  
  
  // Now cycle through the data, again and make rows of the data
  // There is one row per component, these need to be combined based on their session into the same row
  
  // Make an array to hold all of teh data
  // The size is number of sessions by columns in the header
  var currentData = new Array(AllSessionResults.length).fill(null).map(()=>new Array(Ncols).fill(null));

  // cycle over all rows (component results) returned from the database  
  //console.log("Number of rows: "+Nrows)
  for ( var i = 0; i < Nrows; i++ )
  {
    // This is the current component's data
    let currentDataKeys = Object.keys(input.res[i].data)
    
    let currentSessionResult = input.res[i].sessionResultsID
    
    // current row maps each data row to the session
    // get the row in the data table to hold this component's data
    let currentRow = AllSessionResults.indexOf(currentSessionResult)
    //console.log("This row is which session index? "+currentRow)
    //console.log("Current session name: "+input.res[i].sessionName)
    // Fill in the first few columns 
    var startDate = input.res[i].startDate
    var endDate = input.res[i].endDate
    // Tell javascript that these are in UTC time zone by adding a Z
    startDate = startDate + "Z"
    endDate = endDate + "Z"
    // convert to uniz time stamps
    const unixStartDate = Date.parse(startDate);
    const unixEndDate = Date.parse(endDate);
    // convert to JS date objects
    var jsStartDate = new Date(unixStartDate);
    var jsEndDate = new Date(unixEndDate);
    currentData[currentRow][0] = input.res[i].batchName
    currentData[currentRow][1] = input.res[i].workerID
    currentData[currentRow][2] = jsStartDate
    currentData[currentRow][3] = jsEndDate
    if ( input.res[i].sessionName != null )
    {  currentData[currentRow][4] = input.res[i].FirstName }
    if ( input.res[i].sessionName != null )
    {  currentData[currentRow][5] = input.res[i].sessionName }
    if ( input.res[i].sessionName != null )
    {  currentData[currentRow][6] = input.res[i].phase }
    if ( input.res[i].sessionName != null )
    {  currentData[currentRow][7] = input.res[i].test }    
    if ( input.res[i].sessionName != null )
    {  currentData[currentRow][8] = input.res[i].session }    
    let NDataKeys = currentDataKeys.length
    for ( var j = 0; j < NDataKeys; j++ )
    {
      // where to put the current value in the data array

      // this gives the data value
      currentData[currentRow][HeaderRow.indexOf(currentDataKeys[j])] = input.res[i].data[currentDataKeys[j]]
    }
   // console.log(currentData)
  }
  
  // Create the outpout string 
  // Create the output string and add rthe header row to it
  var OutputStr = ''
  
  for ( var k = 0; k < Ncols; k++ ){ OutputStr += '"' + HeaderRow[k] + '"' +"," }
  OutputStr += "\n"

  // cycle over rows
for ( var m = 0; m < AllSessionResults.length; m++ ) {
  // cycle over columns
  for ( var k = 0; k < Ncols; k++ ){ 
    // check to see if there is data inthis cell
      if ( currentData[m][k] == undefined ){ OutputStr += "," }
      else { OutputStr += '"' + currentData[m][k] + '"' + "," }
  }
  OutputStr += "\n"
}
  //console.log(OutputStr)

  
    // Create a Blob with the CSV data and type
    const blob = new Blob([OutputStr], { type: 'text/csv' });
    // Create a URL for the Blob
    const url = URL.createObjectURL(blob);
    // Create an anchor tag for downloading
    const a = document.createElement('a');
    // Set the URL and download attribute of the anchor tag
    a.href = url;
    var today = new Date()
    a.download = GetSelectedBatchName() +"_"+today.toISOString()+".csv";
    // Trigger the download by clicking the anchor tag
    a.click();

  return (<> {Str} </>)
})

const DownloadAllData = () => {
  {MakeData(alldata)}
}


console.log("USERNAME: "+username)
console.log("USERNAME: "+username.toLowerCase())
  return (
    
    <div className={styles.container}>
      <div>
        <h1>
          Welcome to the <br /> NCM Lab Study Manager.
        </h1>

        <p />
        <button onClick={DownloadAllData}>Download data </button>
        <p></p>
        
       {/* <div className={styles.studyManagerLbl}>
          Please pick a study to manage:
        </div>
        <select onChange={(e) => {
          setStudies(studies.filter((s) => s.uuid === e.target.value)[0]);
        }} value={study.uuid}>
          {studies.map((s, i) => {
            return <option
              key={i}
              value={s.uuid}>
              {s.title}
            </option>
          })}
        </select>
          */}
        {/*
        <h2>Links</h2>
        <div>
          JATOS:
        </div>
        <a rel="noreferrer"
          target="_blank" href="https://jatos.ncmlab.ca/jatos/login">
          https://jatos.ncmlab.ca
        </a>
        <div>
          NCM Lab Study Manager Wiki:
        </div>
        <a rel="noreferrer"
          target="_blank" href="https://github.com/chrisvenczel/NeuroClinic/wiki">
          https://github.com/chrisvenczel/NeuroClinic/wiki
        </a>
        <div>
          NCM Lab GitHub:
        </div>
        <a rel="noreferrer"
          target="_blank" href="https://github.com/NCMlab/NCMLabOnlineTools">
          https://github.com/NCMlab/NCMLabOnlineTools
        </a>
        */}
      </div>
    </div>
  );
}

export default Home;